<mat-card appearance="outlined">
  <div class="iframe-container">
    <div class="disable-iframe"></div>
    @if (domain) {
      <iframe
        [src]="siteUrl()"
        tabindex="-1"
        scrolling="no"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin"
      ></iframe>
    } @else {
      <mat-spinner class="info-staging-spinner" mode="indeterminate" color="accent"></mat-spinner>
    }
  </div>
  <mat-card-subtitle
    [hidden]="!domain"
    [innerHTML]="'PAGES.STAGING.MANAGE_STAGING_MODAL.DESCRIPTION' | translate: { domain: domain }"
  ></mat-card-subtitle>
  <mat-card-subtitle>
    {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.PHP_VERSION' | translate }}:
    @if ((phpVersionStagingState$ | async) === '7') {
      <b>7.4.11</b>
    }
    @if ((phpVersionStagingState$ | async) === '8' || (phpVersionStagingState$ | async) === '8.1') {
      <b>8.1</b>
    }
    @if ((phpVersionStagingState$ | async) === '8.2') {
      <b>8.2</b>
    }
    @if ((phpVersionStagingState$ | async) === '8.3') {
      <b>8.3</b>
    }
    <mat-icon class="circle-icon">check_circle</mat-icon>
    <button
      class="change-php-btn"
      mat-button
      color="primary"
      (click)="changeStagingPhpModal()"
      id="PHP_Version_Change_Staging_Button"
      >
      {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.OPEN_CHANGE_PHP_VERSION_DIALOG_BUTTON' | translate }}
    </button>
    <br />
    {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.WORDPRESS_VERSION' | translate }}:
    <b>{{ (stagingWpCoreVersion$ | async) || '-' }}</b>
  </mat-card-subtitle>
  <mat-card-actions>
    <a
      mat-raised-button
      [disabled]="this.editURL === null"
      [href]="navigateToEditSite()"
      data-action="staging-wordpress-edit-site"
      data-action-group="open-wordpress"
      class="wide-button short-button"
      id="loadDiviEditorButton"
      color="accent"
      target="_blank"
      >
      @if (this.editURL !== null) {
        <span>
          {{ 'PAGES.STAGING.MANAGE_STAGING_MODAL.EDIT_MY_SITE' | translate }}
        </span>
      }
    </a>
    <a
      mat-button
      href="/redirect/wp-admin/{{ siteId }}/?instance=staging"
      data-action="staging-wordpress-dashboard"
      data-action-group="open-wordpress"
      class="wide-button short-button"
      id="loadWPAdminButton"
      color="accent"
      target="_blank"
      >
      <span>
        {{ 'PAGES.STAGING.MANAGE_STAGING_MODAL.WORDPRESS_DASHBOARD' | translate }}
      </span>
    </a>
    <a
      mat-button
      href="/redirect/php-my-admin/{{ siteId }}/"
      target="_blank"
      class="wide-button short-button"
      color="accent"
      >
      {{ 'PAGES.STAGING.MANAGE_STAGING_MODAL.PHPMYADMIN' | translate }}
    </a>
    <a mat-button href="{{ sftpPageLink }}" class="wide-button short-button" color="accent">
      {{ 'PAGES.STAGING.MANAGE_STAGING_MODAL.SFTP' | translate }}
    </a>
  </mat-card-actions>
</mat-card>
